var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCwSlashYourFirst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    rx: 27.5,
    fill: "#6A097D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16848_155)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.972,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6289 10.1133C26.9571 10.1133 27.2851 10.1133 27.6133 10.1133C27.6363 11.6537 27.6129 13.1889 27.543 14.7188C25.1488 14.806 22.9339 15.474 20.8984 16.7227C20.0316 15.4334 19.2581 14.0975 18.5781 12.7148C21.0701 11.2318 23.7537 10.3646 26.6289 10.1133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.972,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3171 10.1133C31.5996 10.153 34.623 11.0437 37.3874 12.7852C36.6545 14.1346 35.8694 15.4471 35.032 16.7227C32.9965 15.474 30.7817 14.806 28.3874 14.7188C28.3176 13.1889 28.2941 11.6537 28.3171 10.1133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.97,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8398 13.1367C18.6861 14.4289 19.483 15.7648 20.2305 17.1445C18.3697 18.5015 16.9283 20.2124 15.9062 22.2773C15.8668 22.314 15.8199 22.3375 15.7656 22.3477C14.5593 21.6574 13.3523 20.966 12.1445 20.2734C12.0161 20.2102 11.9223 20.1164 11.8633 19.9922C13.3084 17.2312 15.3006 14.946 17.8398 13.1367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.97,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9492 13.1367C40.5959 14.8791 42.635 17.1642 44.0664 19.9922C44.0073 20.1164 43.9136 20.2102 43.7852 20.2734C42.5827 20.9742 41.3757 21.6656 40.1641 22.3477C39.3364 20.8253 38.2934 19.4542 37.0352 18.2344C36.5871 17.8704 36.1418 17.5071 35.6992 17.1445C36.4687 15.8161 37.2187 14.4802 37.9492 13.1367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.974,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.96484 29.4492C9.96484 28.4648 9.96484 27.4805 9.96484 26.4961C10.162 24.489 10.6894 22.5671 11.5469 20.7305C12.8905 21.4899 14.2147 22.275 15.5195 23.0859C14.7193 25.1368 14.4146 27.2579 14.6055 29.4492C13.0586 29.4492 11.5117 29.4492 9.96484 29.4492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.974,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9648 26.4961C45.9648 27.4805 45.9648 28.4648 45.9648 29.4492C44.418 29.4492 42.8711 29.4492 41.3242 29.4492C41.515 27.2579 41.2104 25.1368 40.4102 23.0859C41.7149 22.275 43.0391 21.4899 44.3828 20.7305C45.2403 22.5671 45.7676 24.489 45.9648 26.4961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.948,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2148 23.1914C39.3855 23.2462 39.3855 23.3282 39.2148 23.4375C36.625 25.7461 34.0351 28.0547 31.4453 30.3633C31.5551 28.5894 30.8169 27.3238 29.2305 26.5664C29.2539 26.543 29.2774 26.5195 29.3008 26.4961C32.6175 25.4061 35.9222 24.3046 39.2148 23.1914Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.968,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6128 27.0596C29.2552 27.0275 30.2747 27.8009 30.6714 29.3799C30.7723 31.0593 30.0105 32.1024 28.3862 32.5088C26.7068 32.6097 25.6637 31.8479 25.2573 30.2236C25.1786 28.5112 25.9637 27.4565 27.6128 27.0596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.968,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0352 30.1528C11.5822 30.1411 13.1291 30.1528 14.6758 30.188C15.0124 32.042 15.6804 33.7647 16.6797 35.356C16.7266 35.4263 16.7266 35.4966 16.6797 35.5669C15.5488 36.2437 14.412 36.9117 13.2695 37.5708C13.0897 37.6851 12.9021 37.7555 12.707 37.7817C11.2509 35.4408 10.3603 32.8979 10.0352 30.1528Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.969,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2539 30.1523C42.8008 30.1523 44.3477 30.1523 45.8945 30.1523C45.5781 32.9305 44.664 35.4852 43.1523 37.8164C41.8142 37.0774 40.5017 36.3039 39.2148 35.4961C40.2271 33.8421 40.9068 32.0608 41.2539 30.1523Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16848_155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(10 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCwSlashYourFirst);
export default __webpack_public_path__ + "static/media/cw-slash-your-first.1df7c8b6b418078cf0163ebe9b76c027.svg";
export { ForwardRef as ReactComponent };